import Discussion from 'shared/components/discussion';
import { SEND_MESSAGE_URL_V1 } from 'shared/components/live/web_socket_url';
import AhoyEvent from 'shared/ahoy_event';
import twemoji from 'twemoji';
import SocketAPI from 'vidio-chat';

export default class EmojiTable {
  constructor({$element: $element}) {
    this.$element = $element;
    this.selector = {
      chatForm: '#new_comment',
      button: '.livestreaming-discussion__table-button',
      chatBox: '.livestreaming-discussion__input',
      tableContainer: ".livestreaming-discussion__table",
      stickerContainer: '.livestreaming-discussion__table-sticker',
      emojiContainer: '.livestreaming-discussion__table-emoji',
      stickerItem: '.livestreaming-discussion__table-item-sticker',
      emojiItem: '.livestreaming-discussion__table-item-emoji',
      emojiTab: '.livestreaming-discussion__table-tab-link-emoji',
      stickerTab: '.livestreaming-discussion__table-tab-link-sticker',
      stickerPack: '.livestreaming-discussion__table-sticker__single',
      stickerPackImage: '.livestreaming-discussion__table-sticker__single img',
    };
    this.ui = {};

    this.stickerPrioritize = [
      "semangat", "hebat", "indonesia", "juara"
    ];

    this.stickerBola = [
      "sedih", "ayo", "gol", "pelanggaran", "kartumerah", "sriwijaya", "mitrakukar", "persija", "arema", "maduraunited", "persib", "perseru", "semenpadang", "psm", "pusamania", "baliunited", "persegres", "persipura", "barito", "surabayaunited", "persiba", "pstni", "persela"
    ];

    this.stickerCandy = [
      'candyangry', 'candybirthday', 'candybored', 'candybroke', 'candydizzy', 'candydontcare', 'candygrumpy', 'candyhi', 'candyhurray', 'candyidea', 'candykiss', 'candylaugh', 'candylove', 'candymakeup', 'candysad', 'candysick', 'candysorry', 'candythanks', 'candywait', 'candywink'
    ];

    this.stickerCotton = [
      'cottonangel', 'cottonbequiet', 'cottonblush', 'cottoncallme', 'cottoncold', 'cottonconfused', 'cottondevil', 'cottonembarrassed', 'cottonfire', 'cottongrin', 'cottongrumpy', 'cottonhi', 'cottonhot', 'cottonjawdrop', 'cottonlaugh', 'cottonletsgo', 'cottonlove', 'cottonmad', 'cottonno', 'cottonokay', 'cottononmyway', 'cottonpickafight', 'cottonraisehand', 'cottonsad', 'cottonshock', 'cottonsick', 'cottonsigh', 'cottonsleep', 'cottonthumbsdown', 'cottonthumbsup', 'cottonyawn', 'cottonyikes'
    ];

    this.stickerList = [].concat(this.stickerPrioritize, this.stickerBola, this.stickerCandy, this.stickerCotton);

    this.emojiList = "😄😃😀😊☺😉😍😘😚😗😙😜😝😛😳😁😔😌😒😞😣😢😂😭😪😥😰😅😓😩😫😨😱😠😡😤😖😆😋😷😎😴😵😲😟😦😧😈👿😮😬😐😕😯😶😇😏😑👲👳👮👷💂👶👦👧👨👩👴👵👱👼👸👹👺💀👽💩";
    this.twemojiPath = window.Config.AssetHostName.replace('%d', Math.floor(Math.random()*2)) + '/assets/images/twemoji/';

    Object.keys(this.selector).forEach((key) => {
      this.ui[key] = $(this.selector[key]);
    });

    this.discussion = new Discussion();
  }

  init() {
    this.ui.button.click(this.onClick.bind(this));
    this.ui.emojiTab.click(this.switchToEmoji.bind(this));
    this.ui.stickerTab.click(this.switchToSticker.bind(this));
    this.emojiInjector();
    this.bindStickerPackClick();
    $(this.ui.stickerPackImage).first().click();
    $('.livestreaming-discussion__submit.ga__livestreaming__submit-comment').on('click', this.hideEmojiTable.bind(this));
  }

  onClick() {
    if ( this.ui.tableContainer.hasClass('hide-me') ) {
      this.showEmojiTable();
    } else {
      this.hideEmojiTable();
    }
  }

  switchToEmoji() {
    this.ui.stickerContainer.addClass('hide-me');
    this.ui.emojiContainer.removeClass('hide-me');
    this.ui.emojiTab.addClass('livestreaming-discussion__table-tab-link--active');
    this.ui.stickerTab.removeClass('livestreaming-discussion__table-tab-link--active');
  }

  switchToSticker() {
    this.ui.stickerContainer.removeClass('hide-me');
    this.ui.emojiContainer.addClass('hide-me');
    this.ui.stickerTab.addClass('livestreaming-discussion__table-tab-link--active');
    this.ui.emojiTab.removeClass('livestreaming-discussion__table-tab-link--active');
  }

  showEmojiTable() {
    this.ui.tableContainer.removeClass('hide-me');
    this.ui.button.data('action', 'view emoticon');
  }

  hideEmojiTable() {
    this.ui.tableContainer.addClass('hide-me');
    this.ui.button.data('action', 'close emoticon');
  }

  emojiInjector() {
    var emoji = $(twemoji.parse(this.emojiList, {
      className: 'livestreaming-discussion__table-item-emoji ga__livestreaming-emoji-item',
    }));
    this.ui.emojiContainer.html(emoji);
    this.bindOnErrorImage();
    this.bindEmojiClick();
  }

  createText(text) {
    const span = document.createElement('span')
    span.setAttribute('class', 'livestreaming-discussion__table-item-emoji')
    span.textContent = text;
    return span;
  }

  bindOnErrorImage() {
    const self = this;
    $('img.livestreaming-discussion__table-item-emoji').on('error', function() {
      if (this.parentNode) {
        this.parentNode.replaceChild(self.createText(this.alt), this);
      }
    })
  }

  stickerInjector(evt) {
    if (window.stickerLists == undefined) {
      return;
    }

    let key = $(evt.target).data("pack");
    let pack_name = $(evt.target).data("pack-name");
    let stickerItems = window.stickerLists[key];

    $(this.selector.stickerItem).remove();
    stickerItems.forEach((item) => {
      var sticker = `<span class="livestreaming-discussion__table-item-sticker sticker sticker-${item} ga__livestreaming-sticker-item" data-name="${item}" data-pack-name="${pack_name}"></span>`;
      this.ui.stickerContainer.append(sticker);
    });
    this.bindStickerClick();
  }

  bindStickerClick() {
    $(this.selector.stickerItem).on('click', this.stickerSubmit.bind(this));
  }

  bindEmojiClick() {
   $(this.selector.emojiItem).on('click', this.appendEmoji.bind(this));
  }

  bindStickerPackClick() {
   $(this.selector.stickerPackImage).on('click', this.stickerInjector.bind(this));
  }

  appendEmoji(e) {
    var emoji = $(e.target).attr('alt');
    $(this.selector.chatBox).val($(this.selector.chatBox).val() + emoji + ' ');

    $(this.selector.chatBox).focus();
  }

  stickerSubmit(e) {
    const livestreamingId =  $('#comment_commentable_id').attr('value');
    const stickerName = $(e.target).data('name');

    var comment = {
      'livestreaming_id': livestreamingId,
      'content': stickerName
    };

    this.sendAjax(comment);
    this.sendStickerAhoyEvent(comment, 'click');
  }

  sendStickerAhoyEvent(commentData, action) {
    const stickerPackId = $(this.selector.stickerPackImage).data('pack');

    AhoyEvent.send('VIDIO::STICKER', {
      action: action,
      page: 'live',
      livestreaming_id: commentData['livestreaming_id'],
      sticker_pack_id: stickerPackId,
      sticker_id: commentData['content']
    });
  }

  sendAjax(commentData) {
    const token = SocketAPI.getToken() || {};
    const CSRFToken = document.querySelector('meta[name="csrf-token"]').content;

    $.ajax({
      method: 'POST',
      url: SEND_MESSAGE_URL_V1,
      data: commentData,
      headers: {
        'Authorization': `Bearer ${token.web}`,
        'X-CSRF-TOKEN': CSRFToken
      }
    }).done(data => {
      this.sendStickerAhoyEvent(commentData, 'send');
      this.renderData(data);
    });
  }

  renderData(data) {
    this.hideEmojiTable();
    this.discussion.renderNewComment(data);
  }
}
